import * as React from 'react'
import OrderInformation from './order_information'

export default function OrderInformationApp(props) {
  return <OrderInformation {...props} />
}
